import styled from "styled-components";
import AprendizImage from "./img/person_super-aprendiz2.png"
import PetalasAnim from "./img/petalas.gif"
import CarrouselItem from "./CarrouselItem/CarrouselItem";
import GtbGif from "./img/golden_bug.gif"
import SphereMedia1 from './img/video_chat.png'
import SphereMedia2 from './img/star.png'
import SphereMedia3 from './img/campaign.png'
import SphereMedia4 from './img/live_help.png'
import { TipMouseOutEvent , TipMouseOverEvent } from "../../Tooltip/Tooltip";
import { useContext, useEffect } from "react";
import AudioGtb from "../../Context/bgm/19.mp3"
import { MusicPlayFunction, WavSoundEffect } from "../../WavSoundEffects/WavSoundEffects";
import { PageContext } from "../../Context/PageContext";
import Guias from "../Guias/Guias";
import NpcIssgardImage from "../Home/img/episode_npc.png"
import StarIcon from "./img/goldstar.png"
import JobIcon from "./img/JobIcon.png"
import DropsIcon from "./img/lunatic.gif"
import ExperienceIcon from "./img/yoyo.gif"
import NoCashIcon from "./img/NoCash.png"
import NoCustomIcon from "./img/NoCustom.png"
import MaxLevelIcon from "./img/MaxLevel.png"
import BalanceIcon from "./img/Balance.png"
import StaffIcon from "./img/Staff.png"

function Home(){

        const { setPage, page } = useContext(PageContext);

        const { musicDuration, setMusicDuration } = useContext(PageContext)
        const { musicDurationTimeLeft, setMusicDurationTimeLeft} = useContext(PageContext)
        const { musicName, setMusicName } = useContext(PageContext)
        const { musicNumber, setMusicNumber } = useContext(PageContext)
        const { controlObject, setcontrolObject } = useContext(PageContext)

        useEffect(() => {
            setTimeout(() => {  document.getElementById("HomeContainer").style.opacity = 1}, 200)}
            
            ,[])

    return(
    <HomeContainer id="HomeContainer">
        <TitleContainer>
            <Title>Ragnarok Online de um jeito diferente.</Title>
            <T1>
                <p>Seja bem vindo! Você está prestes a descobrir um novo mundo de histórias e aventuras  totalmente diferente de tudo o que já viu!<br/>
                Se você procura <b>muita diversão</b> com  <b>desafios moderados</b>, aqui é o <b>seu lugar !</b></p>
            </T1>
        </TitleContainer>

        <MiddleContainer>
                <style>{css}</style>
                <ContentSphere
                onMouseOver={(event) => TipMouseOverEvent(event, "NEWS", "rgb(33, 33, 33)")}
                onMouseLeave={() => TipMouseOutEvent()}
                bgcolorsocialmedia="#F44336"
                spheremedia={SphereMedia1}
                className="AnimationRed" mt={"50px"} mr={"200px"} mb={""} ml={""}/>

                <ContentSphere
                onMouseOver={(event) => TipMouseOverEvent(event, "RANKINGS", "rgb(33, 33, 33)")}
                onMouseLeave={() => TipMouseOutEvent()}
                bgcolorsocialmedia="#FDD835"
                spheremedia={SphereMedia2}
                className="AnimationYellow" mt={"230px"} mr={"300px"} mb={"0px"} ml={""}/>

                <ContentSphere 
                onMouseOver={(event) => TipMouseOverEvent(event, "RATES SERVIDOR", "rgb(33, 33, 33)")}
                onMouseLeave={() => TipMouseOutEvent()}
                bgcolorsocialmedia="#4CAF50"
                spheremedia={SphereMedia3}
                className="AnimationGreen" mt={"230px"} mr={""} mb={""} ml={"300px"}/>

                <ContentSphere
                onMouseOver={(event) => TipMouseOverEvent(event, "GUIA PARA NOVATOS", "rgb(33, 33, 33)")}
                onMouseLeave={() => TipMouseOutEvent()}
                onClick={() => setPage(<Guias/>)}
                bgcolorsocialmedia="#2196F3"
                spheremedia={SphereMedia4}
                className="AnimationBlue" mt={"50px"} mr={""} mb={""} ml={"200px"}/>
            <Aprendiz />
        </MiddleContainer>

        <ColumnMaster>
            
            <Line>
                <EpisodeBox>
                    <RateTitle>Episódeo 19 - Terras Geladas de Issgard</RateTitle><br/><br/>

                    <EpisodeBoxContainer>
                        <NpcImage bg={NpcIssgardImage}/>
                        <EpisodeDescription>
                            O episódio 19 de Ragnarok Online, trouxe uma grande expansão da história principal, aprofundando a narrativa com novos eventos e mistérios.
                            <br/><br/>
                            Entre as novidades, destacam-se:<br/>
                            - A abertura de novas regiões e masmorras, com cenários inéditos para exploração.<br/>
                            - A introdução de novos monstros e chefes mais poderosos para desafiar os jogadores.<br/>
                            - Novos equipamentos, cartas e itens que fortalecem os personagens e oferecem novas possibilidades de build.<br/>
                            - A continuação de missões que expandem a lore do mundo de Rune-Midgard.
                        </EpisodeDescription>
                    </EpisodeBoxContainer>
                </EpisodeBox>
            </Line>
                    
            <Line>
                <SpanComandos>
                    <ConfigureIcons bg={JobIcon} width={'30px'} height={'30px'}/>
                    <RateTitle>Job</RateTitle>
                    3rd Classes <br/>
                    Doram <br/>
                    Classes Expandidas
                </SpanComandos>

                <SpanComandos>
                    <ConfigureIcons bg={DropsIcon} width={'40px'} height={'30px'}/>
                    <RateTitle>Drops</RateTitle>
                    Itens Gerais  - x1<br/>
                    Cartas Normais - x50 <br/>
                    Cartas MVPs - x10 
                </SpanComandos>

                <SpanComandos>
                    <ConfigureIcons bg={ExperienceIcon} width={'40px'} height={'45px'}/>
                    <RateTitle>Experiência</RateTitle>
                    Base - x10 <br/>
                    Classe - x30 <br/>
                </SpanComandos>

            </Line>

            <Line>
                <SpanComandos>
                    <ConfigureIcons bg={NoCashIcon} width={'50px'} height={'50px'}/>
                    <RateTitle>Sem Cash</RateTitle>
                    Todos os Rops Itens são conseguidos atráves de eventos automáticos e pontuais.
                </SpanComandos>

                <SpanComandos>
                    <ConfigureIcons bg={NoCustomIcon} width={'50px'} height={'65px'}/>
                    <RateTitle>Sem Customs</RateTitle>
                    Utilizamos o repertório original de itens do game.
                </SpanComandos>

                <SpanComandos>
                    <ConfigureIcons bg={MaxLevelIcon} width={'40px'} height={'45px'}/>
                    <RateTitle> Max Level</RateTitle>
                    175 / 70 <br/>
                    Instâncias de nível superior estão liberadas para 175/70.
                </SpanComandos>
            </Line>

            <Line>
                <SpanComandos>
                    <ConfigureIcons bg={BalanceIcon} width={'50px'} height={'50px'}/>
                    <RateTitle>Equilibrio</RateTitle>
                    Diversão garantida com desafios moderados, justos e uma comunidade saudável.
                </SpanComandos>

                <SpanComandos>
                    <ConfigureIcons bg={StarIcon} width={'40px'} height={'40px'}/>
                    <RateTitle>VIP</RateTitle>
                    Sistema de doações e acesso VIP com recursos adicionais.
                </SpanComandos>

                <SpanComandos>
                    <ConfigureIcons bg={StaffIcon} width={'60px'} height={'40px'}/>
                    <RateTitle> Staff Ativa</RateTitle>
                    Equipe sempre ativa monitorando e garantido sua diversão.
                </SpanComandos>
            </Line>
                    
        </ColumnMaster>
        
        <CarrouselContainer>
            <PetalasAnimated />
            <CarrouselItem itemUrl="home1"/>
            <CarrouselItem itemUrl="home3"/>
            <CarrouselItem itemUrl="home2"/>
        </CarrouselContainer>

        <GoldenBug
        onMouseOver={(event) => {
            TipMouseOverEvent(event, ".... <br> Não Clique!","rgb(33, 33, 33)");
            WavSoundEffect('/wav/eggyra_move.wav', ' ', 'hover')}}
        onMouseLeave={() => TipMouseOutEvent()}
        onClick={() => WavSoundEffect(' ', '/bgm/19.mp3', 'click')}/>

    </HomeContainer>
    );
};

const HomeContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    transition: 2s;
    margin-bottom: 50px;
    opacity: 0;

    @media (max-width: 1000px) {
    width: 90vw;
    margin-top: 30px;
    }

`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1280px;

    @media (max-width: 1000px) {
    width: 90%;
    //text-align: justify;
    margin-bottom: 50px;
    }
`;

const Title = styled.h1`
    font-size: 30pt;

    @media (max-width: 1000px) {
    font-size: 28pt;
    text-align: center;
    }
`;

const T1 = styled.div`
    width: 1000px;
    padding: 10px 20px;
    //border: solid;
    text-align: center;
    font-size: 13pt;


    @media (max-width: 1000px) {
    width: 100%;
    overflow: auto;
    padding: 10px;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    font-size: 11pt;
    }

`;

const MiddleContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    position: relative;
    //border: solid;

    @media (max-width: 1000px) {
    scale: .6;
    width: 90vw;
    }
`;

const Aprendiz = styled.div`
    background-image: url(${AprendizImage});
    background-size: cover;
    width: 430px;
    height: 438px;

    @media (max-width: 1000px) {
    scale: 1.4;
    }
`;

const ContentSphere = styled.div`
  background-color: ${props => props.bgcolorsocialmedia};
  background-image: url(${props => props.spheremedia});
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  width: 60px;
  height: 60px;
  top: ${props => props.mt};
  right: ${props => props.mr};
  bottom: ${props => props.mb};
  left: ${props => props.ml};
  border-radius: 50%;
  animation-duration: 2s;
  animation-delay: 3s;
  animation-iteration-count: infinite;
  opacity: 1;
  transition: .3s ease-in-out;
  z-index: 2;

  cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

  &:hover {
  opacity: 1;
  scale: 1.0;
  //transform: rotate3d(0, 0, 1, 360deg);
  }

  @media (max-width: 1000px) {
    scale: 1.2;
    top: -160px;
    }
`;

const CarrouselContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 1280px;
    //border: solid 2px black;
    margin-bottom: 50px;
    margin-top: 100px;
    position: relative;

    @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    width: 80vw;
    scale: .9;
    margin-top: 0px;
    margin-bottom: 0px;
    }

`;

const PetalasAnimated = styled.div`
    background-image: url(${PetalasAnim});
    background-size: cover;
    width: 100%;
    height: 900px;
    position: absolute;
    //border: solid;

    @media (max-width: 1200px) {
    margin: 50px 0;
    width: 90vw;
    }
`;

const GoldenBug = styled.div`
    background-image: url(${GtbGif});
    background-size: cover;
    width: 72px;
    height: 52px;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

`;



const css = `
  .AnimationRed {
  animation-name: pulseAnimationRed;
  }

  .AnimationYellow {
  animation-name: pulseAnimationYellow;
  }

  .AnimationGreen {
  animation-name: pulseAnimationGreen;
  }

  .AnimationBlue {
  animation-name: pulseAnimationBlue;
  }

@keyframes pulseAnimationRed {
  0% { box-shadow: 0px 0px 0px 0px rgba(244, 67, 54, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(244, 67, 54, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(244, 67, 54, 0); }
}

@keyframes pulseAnimationYellow {
  0% { box-shadow: 0px 0px 0px 0px rgba(253, 216, 53, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(253, 216, 53, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(253, 216, 53, 0); }
}

@keyframes pulseAnimationGreen {
  0% { box-shadow: 0px 0px 0px 0px rgba(76, 175, 80, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(76, 175, 80, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(76, 175, 80, 0); }
}

@keyframes pulseAnimationBlue {
  0% { box-shadow: 0px 0px 0px 0px rgba(33, 150, 243, 1); }
 70% { box-shadow: 0px 0px 5px 10px rgba(33, 150, 243, 0); }
 100% { box-shadow: 0px 0px 5px 10px rgba(33, 150, 243, 0); }
}
 `

 const VirtuesContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid;
    margin: 0px 0px 20px 0px;
    width: 100%;

    @media (max-width: 1000px) {
    flex-wrap: wrap;
    }
 `

 const VirtueItem = styled.div`
    padding: 5px 20px;
    margin: 0px 5px;
 `

 const ColumnMaster = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 20px;
    //border: solid;
    margin-bottom: 10px;

    @media(max-width: 1000px) {
      width: 90vw;
    }
`

const Line = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    text-align: justify;
    margin: 20px 0px;

    @media(max-width: 1000px) {
      flex-direction: column;
      margin: 5px 0px;
      align-items: center;
    }

`

const SpanComandos = styled.div`
    margin: 0px 15px;
    width: 300px;
    box-shadow: 0px 0px 5px 0px black;
    padding: 15px 0px;
    border-radius: 5px;
    transition: .3s;
    cursor: pointer;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    transform: translate(-5px,-5px);
    scale: 1.1;
    background-color: rgba(31, 112, 169, 1);
    color: white;
    }

    @media(max-width: 1000px) {
      margin: 5px 0px;
      width: 70vw;

      &:hover {
        scale: 1.0;
        }
    }
`

const ConfigureIcons = styled.div`
    width: ${props => props.width};
    height: ${props => props.height};
    background-image: url('${props => props.bg}');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
`
const RateTitle = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin-bottom: 10px;
`

const EpisodeBox = styled.div`
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 5px 0px black;
    width: 950px;
    padding: 30px 0px;
    border-radius: 5px;
    transition: .3s;
    text-align: center;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    transform: translate(-5px,-5px);
    scale: 1.1;
    background-color: rgba(31, 112, 169, 1);
    color: white;
    box-shadow: 5px 5px 5px 0px black;
    }

    @media(max-width: 1000px) {
      width: 300px;
      padding: 30px 10px;
    }
`

const NpcImage = styled.div`
    background-image: url('${props => props.bg}');
    backgroun-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    width: 79px;
    height: 113px;
    margin: 0 20px 0 0;

    @media(max-width: 1000px) {
      margin: 0 0 20px 0;
    }

`

const EpisodeBoxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    @media(max-width: 1000px) {
      flex-direction: column;
    }
`

const EpisodeDescription = styled.div`
    width: 700px;
    text-align: justify;

    @media(max-width: 1000px) {
      width: 90%;
    }
`



export default Home;